import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Clock } from 'lucide-react';
export default function Footer() {
  return <footer className="bg-primary text-white pt-12 pb-6" data-id="element-56" data-mp="eoaf5jc1yksn">
      <div className="container mx-auto px-4" data-id="element-57" data-mp="alno3kn7h3wi">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-58" data-mp="akcev5azr3y0">
          {/* About */}
          <div data-id="element-59" data-mp="5p6sy6hl9p9x">
            <div className="flex items-center mb-4" data-id="element-60" data-mp="nzj81vvyg0m">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hDXV1rDXM1m2ARqkQ9Hg8F/Medico_Favicon.png" alt="Medicolegal Psychiatry Expert Witness Logo" className="h-10 w-auto mr-3" loading="lazy" data-id="element-61" data-mp="orflexb4hry" />
              <h3 className="font-serif text-xl font-bold" data-id="element-62" data-mp="3j30bx0l7tg37">
                Medicolegal Psychiatry
              </h3>
            </div>
            <p className="mb-4 text-sm leading-relaxed" data-id="element-63" data-mp="3e4yuek3ftotu">
              Medico-Legal Psychiatry is led by Dr Imtiaz Syed, a GMC registered
              Psychiatrist and accredited Expert Witness. With over 20 years of
              clinical experience, we are committed to providing clear,
              impartial, and evidence-based psychiatric assessments across the
              UK.
            </p>
            <p className="text-sm leading-relaxed" data-id="element-64" data-mp="2babwgt4ndanj">
              Our services are guided by the principles of Clarity, Compassion,
              and Expertise, ensuring reliability and professionalism in every
              case.
            </p>
          </div>
          {/* Opening Hours */}
          <div data-id="element-65" data-mp="380l5x67ds0ql">
            <h3 className="font-serif text-xl font-bold mb-4 flex items-center" data-id="element-66" data-mp="380cp53850ba4">
              <Clock className="mr-2 h-5 w-5" data-id="element-67" data-mp="2u50mm9nqpgin" />
              Opening Hours
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-68" data-mp="2z067r69bir5o">
              <li className="flex justify-between" data-id="element-69" data-mp="1in7yh83z1wl9">
                <span data-id="element-70" data-mp="1img0xrqtdosc">Monday:</span>
                <span data-id="element-71" data-mp="1nmkkjqn0qzms">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-72" data-mp="1no5f3g9c2ikn">
                <span data-id="element-73" data-mp="13kzfspob78yh">Tuesday:</span>
                <span data-id="element-74" data-mp="13k7rlzx1kdi8">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-75" data-mp="ziw17s6cfo8z">
                <span data-id="element-76" data-mp="zl8rcsm994x4">Wednesday:</span>
                <span data-id="element-77" data-mp="urw3ikpeh25f">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-78" data-mp="uqbdn8e167dw">
                <span data-id="element-79" data-mp="ps9tsl8s641d">Thursday:</span>
                <span data-id="element-80" data-mp="pr8hkdg13bi2">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-81" data-mp="kvay3y9gxp12">
                <span data-id="element-82" data-mp="krvm54b3cw3v">Friday:</span>
                <span data-id="element-83" data-mp="fuvmbb4u4pl7">9:00am – 5:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-84" data-mp="fxhrx5860v0s">
                <span data-id="element-85" data-mp="buctbdr7hdhf">Saturday:</span>
                <span data-id="element-86" data-mp="bveh8itblugk">9:00am – 1:00pm</span>
              </li>
              <li className="flex justify-between" data-id="element-87" data-mp="6vs2u61ra866">
                <span data-id="element-88" data-mp="267kvxrlfatdm">Sunday:</span>
                <span data-id="element-89" data-mp="266ji5fd0vss7">Closed</span>
              </li>
            </ul>
          </div>
          {/* Quick Links */}
          <div data-id="element-90" data-mp="219163g3pkxfz">
            <h3 className="font-serif text-xl font-bold mb-4" data-id="element-91" data-mp="2199m3gv4oive">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-92" data-mp="28r7mmvvc0jmh">
              <li data-id="element-93" data-mp="2dr3td2veyp5q">
                <Link to="/about" className="hover:text-secondary transition-colors" data-id="element-94" data-mp="2dqkejv128gvx">
                  About Dr. Syed
                </Link>
              </li>
              <li data-id="element-95" data-mp="2nfvgmxpj4lab">
                <Link to="/services" className="hover:text-secondary transition-colors" data-id="element-96" data-mp="2ngdn0n5wofvy">
                  Our Services
                </Link>
              </li>
              <li data-id="element-97" data-mp="1ushpjg8iijy4">
                <Link to="/faq" className="hover:text-secondary transition-colors" data-id="element-98" data-mp="1uu2kv82ni6x1">
                  FAQs
                </Link>
              </li>
              <li data-id="element-99" data-mp="3b6hq8tf6mdmf">
                <Link to="/contact" className="hover:text-secondary transition-colors" data-id="element-100" data-mp="3b70vpannb9jk">
                  Contact Us
                </Link>
              </li>
              <li className="pt-2" data-id="element-101" data-mp="3dq4bhi6bnbnw">
                <Link to="/policies/privacy" className="hover:text-secondary transition-colors" data-id="element-102" data-mp="3dr5z0m4ixqmi">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-103" data-mp="3nmqwc6yne2px">
                <Link to="/policies/terms" className="hover:text-secondary transition-colors" data-id="element-104" data-mp="3iqa9dg36puef">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-105" data-mp="3rpnjmaz4un07">
                <Link to="/policies/cancellation" className="hover:text-secondary transition-colors" data-id="element-106" data-mp="3rq5kjkwqppeg">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-107" data-mp="javc7v29bny8">
                <Link to="/sitemap" className="hover:text-secondary transition-colors" data-id="element-108" data-mp="jadj37aw5puj">
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div className="lg:col-span-1" data-id="element-109" data-mp="xvhplnyh8s56">
            <h3 className="font-serif text-xl font-bold mb-4" data-id="element-110" data-mp="12wx7j75cyijc">Customer Care</h3>
            <div className="flex items-start mb-4" data-id="element-111" data-mp="ox5y7jpsdqbo">
              <Mail className="h-5 w-5 mr-2 mt-0.5" data-id="element-112" data-mp="owe0o3cmpiir" />
              <div data-id="element-113" data-mp="tvh8fvjzu2uf">
                <p className="font-medium" data-id="element-114" data-mp="tuxroi62xkhz">Email:</p>
                <a href="mailto:enquiries@medicolegal-psychiatry.co.uk" className="text-secondary hover:underline break-words" data-id="element-115" data-mp="txtlbuaw9n0m">
                  enquiries@medicolegal-psychiatry.co.uk
                </a>
              </div>
            </div>
            <div className="mt-6" data-id="element-116" data-mp="64l82a1h1zbk">
              <h4 className="font-medium mb-2" data-id="element-117" data-mp="a785qrktqego">Accreditations:</h4>
              <div className="flex flex-wrap gap-2" data-id="element-118" data-mp="a5ndx9pw99mi">
                <a href="https://www.medco.org.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-119" data-mp="3sexlwlww3o42">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8X52QHFHr2pezRgSGP8PRu/Medco.png" alt="MedCo Accredited Medical Expert" className="h-8" loading="lazy" data-id="element-120" data-mp="22yll8ctma6t0" />
                </a>
                <a href="https://www.gmc-uk.org/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-121" data-mp="1p2zplmsvoorm">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bdKLxaE25XhPcbz47Q5ek2/GMC.png" alt="General Medical Council (GMC) Registered" className="h-8" loading="lazy" data-id="element-122" data-mp="2cuewztzihw9q" />
                </a>
                <a href="https://ico.org.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-123" data-mp="wfvohswwoul4">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oejz6MBWaYPHLboKrsxoJ8/ICO.png" alt="Information Commissioner's Office (ICO) Registered" className="h-8" loading="lazy" data-id="element-124" data-mp="rccr7d8cm9jc" />
                </a>
                <a href="https://www.rcpsych.ac.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-125" data-mp="152gb3xjr9r5m">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9akzzny18c2cokdDbeaSwa/RCPsych.png" alt="Professional psychiatric membership body logo" className="h-8" loading="lazy" data-id="element-126" data-mp="1k08ks92mflbw" />
                </a>
                <a href="https://www.bondsolon.com/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-127" data-mp="1rjhslxvhbbyu">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/r7LQZ1MUtT9MjPyaNm53VY/Bond_Solon.jpg" alt="Certified expert witness training provider logo" className="h-8" loading="lazy" data-id="element-128" data-mp="2189js3spts8p" />
                </a>
                <a href="https://www.medschools.ac.uk/" target="_blank" rel="noopener noreferrer" className="transition-opacity hover:opacity-80" data-id="element-129" data-mp="13nna4kmn1kuq">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6MiZXdLANurvspjz8K3bmS/medical_school_council.png" alt="Medical School Council Recognised" className="h-8" loading="lazy" data-id="element-130" data-mp="2t0gzn20ed0m1" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20 mt-8 pt-6 text-center text-sm" data-id="element-131" data-mp="31feniv3bj6rd">
          <p data-id="element-132" data-mp="2mmbejc3sm1c9">
            © {new Date().getFullYear()} Medicolegal Psychiatry. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}